export function tempTraveller() {
    return {
        adults: 1,
        childrens: 1,
        rooms: 0
    }
}

import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';
import { ApiHandlerService } from '../../core/api-handlers';
import { AlertService } from '../../core/services/alert.service';
import { UtilityService } from '../../core/services/utility.service';
import { AppGlobal } from '../../app.global';

@Injectable({
    providedIn: 'root'
})
export class HotelService implements OnDestroy {

    isDevelopment = false;
    formFilled: BehaviorSubject<any> = new BehaviorSubject<any>({});
    searchHotelSubmitted: any = false;
    hotels = new BehaviorSubject<any>([]);
    hotelsCopy = new BehaviorSubject<any>([]);
    loading = new BehaviorSubject<boolean>(false);
    changeDetectionEmitter: EventEmitter<void> = new EventEmitter<void>();
    private _hotelsCopy: any = [];
    maxPrice = new BehaviorSubject<any>(0);
    minPrice = new BehaviorSubject<any>(0);
    myValue = new BehaviorSubject<any>(0);
    myValueStart = new BehaviorSubject<any>(0);
    searchingHotel = new BehaviorSubject<any>('');
    hotelPromocode = new BehaviorSubject<any>({});
    currentCurrency: any;
    currentCurrencyRate: any;
    noHotel = new BehaviorSubject<boolean>(false);
    isRefundable = new BehaviorSubject<boolean>(false);
    isNonRefundable = new BehaviorSubject<boolean>(false);
    serverError = new BehaviorSubject<boolean>(false);
    searchResponseCopy = new BehaviorSubject<any>(false);
    nearByAirportsCopy = new BehaviorSubject<any>([]);
    traveller: any = this.isDevelopment ? tempTraveller() : undefined;
    resultToken: any;
    appReference: any;
    bookingHotelData = new BehaviorSubject<any>(undefined);
    blockHotelRoom = new BehaviorSubject<any>(undefined);
    userTitleList = new BehaviorSubject<any>([]);
    countryList = new BehaviorSubject<any>(false);
    addHotelBookingPaxDetails: BehaviorSubject<any> = new BehaviorSubject<any>({});
    hotelConfirmationData: BehaviorSubject<any> = new BehaviorSubject<any>({});
    hotelVoucherData: BehaviorSubject<any> = new BehaviorSubject<any>({});
    isCollapsed = new BehaviorSubject<boolean>(true);
    ratingReset = new BehaviorSubject<boolean>(false);
    rating1 = new BehaviorSubject<boolean>(false);
    rating2 = new BehaviorSubject<boolean>(false);
    rating3 = new BehaviorSubject<boolean>(false);
    rating4 = new BehaviorSubject<boolean>(false);
    rating5 = new BehaviorSubject<boolean>(false);
    stars: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    applySortingAfterFilter = new BehaviorSubject<boolean>(false);
    private refundableFilter = { isRefundable: false, isNonRefundable: false };
    availableOptions: {} = {
        stars: [],
        sorts: []
    };
    hotelSearchData: BehaviorSubject<{}[]> = new BehaviorSubject<any>([]);
    amenities: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    scrollToRoomDetails: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    clearAmenities = new BehaviorSubject<boolean>(false);
    clearRating = new BehaviorSubject<boolean>(false);
    clearHotelName = new BehaviorSubject<boolean>(false);
    private subSunk = new SubSink();
    searchHotelName = new BehaviorSubject<string>(undefined);
    bookingApiSources = [];
    selectedPOIs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    selectedHotelPOIs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    selectedHotelFacilities: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    selectedAccommodationCodes: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    constructor(
        private apiHandlerService: ApiHandlerService,
        private alertService: AlertService,
        private utility: UtilityService,
    ) {
        this.apiHandlerService.apiHandler('userTitleList', 'POST', {}, {}, {}).subscribe(res => {
            this.userTitleList.next(res.data);
        });
        this.apiHandlerService.apiHandler('countryList', 'POST').subscribe(res => {
            this.countryList.next(res.data.popular_countries.concat(res.data.countries));
        });
    }
    counter = 0;
    searchResult(data: any) {
        this.bookingApiSources = ['ZBAPINO00008'];
        //TLAPINO00004
        this.searchResultApi(data)
    }


    searchResultApi(data: any) {
        if (data['RoomGuests']) {
            data['RoomGuests'].forEach(element => {
                element.ChildAge = this.setChildAge(element);
            });
        }
        const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
        data["UserId"] = created_by_id;
        data["UserType"] = "B2C";
        data.booking_source = this.bookingApiSources[0];
        this.searchHotelSubmitted = true;
        this.searchingHotel.next(true);
        this.loading.next(true);
        this.resetSearch();
        this.hotels.next([]);
        this.subSunk.sink = this.apiHandlerService.apiHandler('searchHotel', 'post', '', '', data).subscribe(
            searchResponse => {
                if (searchResponse.statusCode == 200 && Object.keys(searchResponse.data?.length)) {
                    if (this.counter == 1) {
                        // let mergeResponseData = [...this.hotels.value, ...searchResponse['data']]
                        // searchResponse['data'] = mergeResponseData;
                        this.getResponse(searchResponse.data);
                        this.counter--;
                    } else if (!this.counter) {
                        this.getResponse(searchResponse.data);
                        this.counter++;

                    }
                    this.bookingApiSources.shift();
                    data.booking_source = this.bookingApiSources[0];
                    if (this.bookingApiSources.length > 0) {
                        this.searchResultApi(data);
                    }
                    // if (data.booking_source == "TLAPINO00001") {
                    //     data.booking_source = "TLAPINO00002";
                    //     this.searchResult(data);
                    // }
                    //   this.getResponse(searchResponse.data);
                } else if (searchResponse.statusCode == (200 || 400) && Object.keys(searchResponse.data).length === 0) {
                    // console.log("No data", searchResponse.data)
                    this.noHotel.next(true);
                    this.alertService.error(searchResponse.Message);
                } else {
                    this.noHotel.next(true);
                    this.alertService.error(searchResponse.Message);
                }
                this.serverError.next(false);
                this.searchingHotel.next(false);
                this.loading.next(false);
                this.changeDetectionEmitter.emit();
            }, (error) => {
                this.serverError.next(true);
                this.loading.next(false);
                this.hotels.next(error.error);
            }
        );
    }

    getResponse(searchResponse: any) {
        this.searchResponseCopy.next(JSON.parse(JSON.stringify(searchResponse)));
        this.hotels.next(searchResponse);
        this.changeDetectionEmitter.emit();
        const hotelsCopy = JSON.parse(JSON.stringify(searchResponse));
        this.hotelsCopy.next(hotelsCopy);
        this._hotelsCopy = hotelsCopy;
        let maxPrice = Math.max.apply(Math, hotelsCopy.map(o => o['Price']['Amount']));
        maxPrice = maxPrice == -Infinity ? 1 : maxPrice;
        this.maxPrice.next(maxPrice);
        let minPrice = Math.min.apply(Math, hotelsCopy.map(o => o['Price']['Amount']));
        minPrice = minPrice == -Infinity ? 1 : minPrice;
        this.minPrice.next(minPrice);
        this.myValue.next(maxPrice);
        this.myValueStart.next(minPrice);
    }

    resetSearch() {
        this.hotelsCopy.next([]);
        this.hotels.next([]);
        this.maxPrice.next(0);
        this.minPrice.next(0);
        this.myValue.next(0);
        this.myValueStart.next(0);
        this.changeDetectionEmitter.emit();
    }

    changeSlider() {
        this.multipleFiltersApply();
    }

    changeSliderExt() {
        console.log(this.myValue, this.myValueStart, "myval")
        this.myValue.next(Math.ceil(this.myValue.value));
        this.myValueStart.next(Math.floor(this.myValueStart.value));
        const result = this._hotelsCopy.filter(hotel => {
            const result = hotel.Price.Amount <= this.myValue.value && hotel.Price.Amount >= this.myValueStart.value;
            return result;
        });
        console.log(result, "changeSliderExt()")
        return !result.length ? this._hotelsCopy : result;
    }

    filterByStar() {
        this.multipleFiltersApply();
    }

    filterByStarEtx(hotels) {
        const tempStars = this.stars.value.filter(h => h.isChecked);
        if (this.stars.value.length === tempStars.length || tempStars.length === 0) {
            return hotels;
        }
        let tempHotels = [];
        for (let hotel of hotels) {
            const result = this.stars.value.find(t => t.stars === (Math.ceil(Number(hotel.StarRating))));
            if (typeof result !== 'undefined' && result.isChecked) {
                tempHotels.push(hotel);
            }
        }
        return tempHotels;
    }

    filterByAmenitiesExt(hotels) {
        const tempAmenities = this.amenities.value.filter(a => a.isChecked);
        if (this.amenities.value.length === tempAmenities.length || tempAmenities.length === 0) {
            return hotels;
        }
        const hotelCopyTemp = [...hotels];
        let tempHotels = [];
        for (let hotel of hotelCopyTemp) {
            let providedAmenities = hotel['HotelAmenities'] || [];
            providedAmenities = ((providedAmenities.join('')).replace(/_/gi, '')).toLowerCase();
            const result = this.amenities.value.find(t => {
                const match = new RegExp(`${t['amenity'].toLowerCase()}`, "gi");
                return t.isChecked && providedAmenities.match(match) !== null;
            });
            if (typeof result !== 'undefined' && result.isChecked) {
                tempHotels.push(hotel);
            }
        }
        return tempHotels;
    }

    filterByAmenities() {
        this.multipleFiltersApply();
    }

    filterByRefundable(hotels) {
        // Get the current state of the flags
        const isRefundable = this.isRefundable.getValue();
        const isNonRefundable = this.isNonRefundable.getValue();
    
        // Check if neither checkbox is selected; if so, return the full list
        if (!isRefundable && !isNonRefundable) {
            return hotels;
        }
    
        return hotels.filter(hotel => {
            if (isRefundable && hotel.Refundable) {
                return true;  // Include refundable hotels
            }
            if (isNonRefundable && !hotel.Refundable) {
                return true;  // Include non-refundable hotels
            }
            return false;
        });
    }
    


    filterByNearbyPOI(hotels) {
        // Get the current array of selected POIs from BehaviorSubject
        const selectedPOIs = this.selectedPOIs.getValue() || [];

        // If no POIs are selected, return the full list of hotels
        if (selectedPOIs.length === 0) {
            return hotels;
        }

        // Filter hotels based on selected POIs
        return hotels.filter(hotel => {
            let nearbyLocations = [];

            // Parse NearByLocation if it is a JSON string
            if (typeof hotel.NearByLocation === 'string') {
                try {
                    nearbyLocations = JSON.parse(hotel.NearByLocation);
                } catch (error) {
                    console.error('Error parsing NearByLocation:', error);
                    return false;  // Skip this hotel if there is an error
                }
            } else if (Array.isArray(hotel.NearByLocation)) {
                nearbyLocations = hotel.NearByLocation;
            }

            // Check if any of the nearby locations match the selected POIs
            return nearbyLocations.some(loc =>
                selectedPOIs.includes(loc.poiName.trim())
            );
        });
    }

    resetRefundableFilters() {
        this.isRefundable.next(false);
        this.isNonRefundable.next(false);

        // Reset hotels to the original state
        this.hotels.next(this.hotelsCopy.getValue());

        // Reapply filters
        this.multipleFiltersApply();
    }



    multipleFiltersApply() {
        let hotels = this.changeSliderExt();
        hotels = this.filterByStarEtx(hotels);
        hotels = this.filterByHotelNameExt(hotels);
    
        // Apply refundable/non-refundable filters
        hotels = this.filterByRefundable(hotels);
    
        hotels = this.filterByNearbyPOI(hotels);
        hotels = this.filterHotelsByPOI(hotels);
        hotels = this.filterHotelsByFacilities(hotels);
        hotels = this.filterHotelsByAccommodation(hotels);
        
        // Update the filtered hotels observable
        this.hotels.next(hotels);
    }
    


    setByNearByLoc() {
        this.multipleFiltersApply();
    }

    setByPOI() {
        this.multipleFiltersApply();
    }

    filterHotelsByPOI(hotels) {
        // Get the current array of selected POIs from BehaviorSubject
        const selectedHotelPOIs = this.selectedHotelPOIs.getValue() || [];

        // If no POIs are selected, return the full list of hotels
        if (selectedHotelPOIs.length === 0) {
            return hotels;
        }

        // Filter hotels that have at least one matching POI in the selected POIs array
        return hotels.filter(hotel => {
            // Assuming hotel.PoinOfInterest is already an array
            const nearbyLocations = hotel.PoinOfInterest || [];

            // Check if any of the nearby locations match the selected POIs
            return nearbyLocations.some(loc =>
                selectedHotelPOIs.includes(loc.poiName.trim())
            );
        });
    }


    setHotelFacility() {
        this.multipleFiltersApply();
    }

    filterHotelsByFacilities(hotels) {
        // Get the current array of selected facilities from BehaviorSubject
        const selectedFacilities = this.selectedHotelFacilities.getValue() || [];

        // If no facilities are selected, return the full list of hotels
        if (selectedFacilities.length === 0) {
            return hotels;
        }

        // Filter hotels that have at least one matching facility in the selected facilities array
        return hotels.filter(hotel => {
            // Assuming hotel.facilities is already an array
            const hotelFacilities = hotel.facilities || [];

            // Check if any of the facilities match the selected facilities
            return hotelFacilities.some(facility =>
                selectedFacilities.includes(facility.facility_code)
            );
        });
    }

    setHotelAccomodation() {
        this.multipleFiltersApply();
    }

    filterHotelsByAccommodation(hotels) {
        // Get the current array of selected accommodation codes from BehaviorSubject
        const selectedAccommodationCodes = this.selectedAccommodationCodes.getValue() || [];

        // If no accommodation codes are selected, return the full list of hotels
        if (selectedAccommodationCodes.length === 0) {
            return hotels;
        }

        // Filter hotels that match any of the selected accommodation codes
        return hotels.filter(hotel =>
            selectedAccommodationCodes.includes(hotel.AccommodationCode)
        );
    }



    setHotelInvoiceNumber(appReference) {
        let invoiceNumber = "";
        if (appReference) {
            invoiceNumber = "INV-" + (appReference.split("-")[1]);
        }
        return invoiceNumber;
    }

    setChildAge(child) {
        let childAge = [];
        if (child && child.ChildAge) {
            child.ChildAge.forEach(element => {
                childAge.push(element.childAge.toString());
            });
            return childAge;
        }
    }

    setHotelTraveller() {
        const storedState = localStorage.getItem('hotelTraveller');
        if (storedState) {
            console.log(storedState);
            this.traveller = (JSON.parse(storedState));
        }
    }

    resetFilter() {

        this.clearPrice();
        this.resetRefundableFilters();
        this.clearRatingFilter();
        this.clearHotelName.next(true);
        this.clearAminitiesFilter();

        this.selectedPOIs.next([]);
        this.selectedHotelPOIs.next([]);
        this.selectedAccommodationCodes.next([]);
        this.selectedHotelFacilities.next([]);

        this.hotels.next(this.hotelsCopy.getValue());
        this.multipleFiltersApply();
    }

    clearPrice() {
        this.myValue.next(this.maxPrice.value);
        this.myValueStart.next(this.minPrice.value);
        this.maxPrice.next(this.maxPrice.value);
        this.minPrice.next(this.minPrice.value);
        this.changeSlider();
    }

    resetPOIFilter() {
        this.selectedHotelPOIs.next([]); // Clear the selected POIs
        this.hotels.next(this.hotelsCopy.getValue()); // Reset to the original hotels list
        this.setByPOI(); // Reapply filters with cleared POIs
    }

    clearRatingFilter() {
        this.clearRating.next(true);
    }

    clearAminitiesFilter() {
        this.clearAmenities.next(true);
    }

    filterByHotelName(searchText) {
        this.searchHotelName.next(searchText);
        this.multipleFiltersApply();
    }

    filterByHotelNameExt(hotels) {
        const searchText = this.searchHotelName.getValue();
        if (!searchText) {
            return hotels;
        }
        let searchHotelName = searchText.trim();
        const searchTerm = searchHotelName.toLowerCase();
        return hotels.filter(hotel => hotel.HotelName.toLowerCase().includes(searchTerm));
    }

    ngOnDestroy() {
        this.subSunk.unsubscribe();
    }

}

